import { onMounted, onUnmounted } from "vue"
import { removeToken, getToken } from "@/utils/auth"
import { ElMessageBox } from "element-plus"

// 无操作超时时间（毫秒）
const IDLE_TIMEOUT = 30 * 60 * 1000 // 30分钟

const ACTIVITY_EVENTS = [
  "mousedown",
  "mousemove",
  "keydown",
  "scroll",
  "touchstart",
  "click"
]

/**
 * 全局空闲超时自动退出登录
 * 用户无操作超过指定时间后，强制退出登录
 */
export function useIdleTimeout() {
  let timer: ReturnType<typeof setTimeout> | null = null
  let isShowingDialog = false

  const resetTimer = () => {
    if (timer) clearTimeout(timer)
    // 未登录状态不启动计时器
    const token = getToken()
    if (!token?.accessToken) return

    timer = setTimeout(() => {
      handleTimeout()
    }, IDLE_TIMEOUT)
  }

  const handleTimeout = async () => {
    // 未登录状态不处理
    const token = getToken()
    if (!token?.accessToken) return

    // 防止重复弹窗
    if (isShowingDialog) return
    isShowingDialog = true

    try {
      await ElMessageBox.alert(
        "由于长时间未操作，系统已自动退出登录，请重新登录。",
        "会话超时",
        {
          confirmButtonText: "重新登录",
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: "warning"
        }
      )
    } catch {
      // 用户点击了关闭
    } finally {
      isShowingDialog = false
      // 清除登录状态
      removeToken()
      sessionStorage.clear()
      window.location.replace("/login")
    }
  }

  const startListening = () => {
    ACTIVITY_EVENTS.forEach(event => {
      document.addEventListener(event, resetTimer, { passive: true })
    })
    resetTimer()
  }

  const stopListening = () => {
    ACTIVITY_EVENTS.forEach(event => {
      document.removeEventListener(event, resetTimer)
    })
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
  }

  onMounted(() => {
    startListening()
  })

  onUnmounted(() => {
    stopListening()
  })

  return { resetTimer, stopListening }
}
